import appointment from "./modules/appointment";

const server = {
  appointment
};

export default server;

/**
 *
 * 调用api方法(api已在main.js全局引入)
 *
 * let params = {}
 * this.$server.user.actionLogin(params).then(res => {})
 */
